import { render, staticRenderFns } from "./eventEnclosure.vue?vue&type=template&id=7c8d2274&scoped=true"
import script from "./eventEnclosure.vue?vue&type=script&lang=js"
export * from "./eventEnclosure.vue?vue&type=script&lang=js"
import style0 from "./eventEnclosure.vue?vue&type=style&index=0&id=7c8d2274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d2274",
  null
  
)

export default component.exports